import React from "react";
import { Container } from "../../container";

function ErrorPage() {
  return (
    <div className="fullHeightLayout">
      <Container>
        <h1>Error Page</h1>
      </Container>
    </div>
  );
}

export default ErrorPage;
